import { Button, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from 'Styles/styles.module.css';

const EditViewToggleButton = ({
  editState = false,
  toggleHandler = () => {},
  editText = 'Edit',
  viewText = 'View',
  miniVersion = false,
  className,
  ...props
}) => {
  return (
    <Tooltip
      compact
      content={editState ? 'Done editing' : 'Click to edit'}
      hoverOpenDelay={200}>
      <Button
        minimal
        small={miniVersion}
        className={className ? className : styles.primary_button_minimal}
        icon={!editState ? 'edit' : 'eye-open'}
        onClick={toggleHandler}
        // title={`${editState ? 'Done editing' : 'Click to edit'}`}
        {...props}>
        {!miniVersion && `${!editState ? editText : viewText}`}
      </Button>
    </Tooltip>
  );
};

EditViewToggleButton.propTypes = {
  editState: PropTypes.bool,
  toggleHandler: PropTypes.func,
  editText: PropTypes.string,
  viewText: PropTypes.string,
  disabled: PropTypes.bool,
  miniVersion: PropTypes.bool,
  className: PropTypes.string,
};

export default EditViewToggleButton;
